{
  "error": "錯誤",
  "help": "說明",
  "info": "資訊",
  "success": "成功",
  "warning": "警告"
}
